"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decryptJWEWithLexi = exports.encryptForMe = exports.encryptForDid = void 0;
const utf8 = __importStar(require("@stablelib/utf8"));
const did_jwt_1 = require("did-jwt");
const did_1 = require("./did");
const encryption_key_box_1 = __importDefault(require("./encryption_key_box"));
const key_1 = require("./key");
/**
 * Encrypt the payload for the DID
 * @param json
 * @param recipient
 * @param resolve
 */
const encryptForDid = async (json, recipient, resolve = did_1.resolveDID) => {
    const didJwtResolver = { resolve };
    const encoded = utf8.encode(JSON.stringify(json));
    const encrypters = await (0, did_jwt_1.resolveX25519Encrypters)([recipient], didJwtResolver);
    return (0, did_jwt_1.createJWE)(encoded, encrypters);
};
exports.encryptForDid = encryptForDid;
/**
 * Encrypt the payload for my DID, using a DID resolver that knows about Lexi, i.e.
 * will artificially add to the DID my encryption key based on my signing key.
 * @param json
 * @param me
 * @param signer
 * @param options
 * @param encryptionKey
 */
const encryptForMe = async (json, me, signer, options, encryptionKey) => {
    const publicSigningString = options.publicSigningString || key_1.singleUsePublicString;
    const resolve = options.resolve || did_1.resolveDID;
    const lexiResolve = (0, did_1.lexiResolver)(resolve, signer, encryptionKey, publicSigningString);
    return {
        signingString: publicSigningString,
        algorithm: "ED25519",
        schema: "lexi-encryption-v1",
        payload: await (0, exports.encryptForDid)(json, me, lexiResolve),
    };
};
exports.encryptForMe = encryptForMe;
const decryptJWEWithLexi = async (encryptionPackage, signer, publicString, encryptionKeyBox) => {
    const publicSigningString = encryptionPackage.signingString;
    const finalEncryptKeyBox = publicSigningString === publicString
        ? encryptionKeyBox
        : new encryption_key_box_1.default();
    const keyPair = await (0, key_1.generateX25519KeyPairFromSignature)(signer, publicSigningString, finalEncryptKeyBox);
    const decrypter = (0, did_jwt_1.x25519Decrypter)(keyPair.secretKey);
    const decrypted = await (0, did_jwt_1.decryptJWE)(encryptionPackage.payload, decrypter);
    return JSON.parse(utf8.decode(decrypted));
};
exports.decryptJWEWithLexi = decryptJWEWithLexi;
